import React, { useEffect } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";

const MacAddressVentor = ({
  show,
  setShow,
  macVentorData,
  loading,
  nameData,
}) => {
  const { t } = useTranslation();

  const isLoading = loading;

  return (
    <ComponentCustomModal
      show={show}
      setShow={setShow}
      centered
      size="md"
      header={`${nameData} ${t("Mac_Address_Ventor")}`}
    >
      {isLoading ? (
        <div className="p-2 placeholder-glow">
          <p className="placeholder-col-12">
            <span className="placeholder col-4 me-2 rounded"></span>
            <span className="placeholder col-7 rounded "></span>
          </p>
          <p className="placeholder-col-12">
            <span className="placeholder col-4 me-2 rounded"></span>
            <span className="placeholder col-7  rounded"></span>
          </p>
        </div>
      ) : (
        <div className="p-2">
          {/* Mac Address Row */}
          <div className="d-flex align-items-center mb-2">
            <div className="fw-semibold " style={{ width: "120px" }}>
              Mac Address
            </div>
            <div className="me-2">:</div>
            <div className="text-dark font-monospace">
              {macVentorData?.macAddress}
            </div>
          </div>

          {/* Company Row */}
          <div className="d-flex align-items-center">
            <div className="fw-semibold " style={{ width: "120px" }}>
              Company
            </div>
            <div className="me-2">:</div>
            <div className="text-dark">{macVentorData?.company}</div>
          </div>
        </div>
      )}
    </ComponentCustomModal>
  );
};

export default MacAddressVentor;
